<script setup>
import { computed } from 'vue';
import BaseCell from 'dashboard/components/table/BaseCell.vue';
import Avatar from 'dashboard/components/widgets/Avatar.vue';
import BrandIcon from 'dashboard/components/BrandIcon.vue';
import { useMapGetter } from 'dashboard/composables/store';

const { row } = defineProps({
  row: { type: Object, required: true },
});

const isRTL = useMapGetter('accounts/isRTL');

const username = computed(() => row?.original?.agent || '');
const avatarSize = 32;
</script>

<template>
  <BaseCell>
    <div class="items-center flex text-left" :class="{ 'flex-row-reverse': isRTL }">
      <div class="relative flex-shrink-0" style="width: 32px; height: 32px;">
        <template v-if="row.original.thumbnail">
          <img
            :src="row.original.thumbnail"
            alt="avatar"
            class="w-8 h-8 rounded-full object-cover block"
            draggable="false"
          />
        </template>
        <template v-else>
          <Avatar :username="username" class="w-8 h-8 rounded-full" />
        </template>

        <div
          class="absolute bottom-0 rounded-full overflow-hidden"
          style="width: 13px; height: 13px; right:-2px; bottom:1px"
        >
          <BrandIcon name="messenger" :size="14" />
        </div>
      </div>

      <div class="items-start flex flex-col min-w-0 my-0 mx-[3px]">
        <h6 class="overflow-hidden text-sm m-0 leading-[1.2] text-slate-800 dark:text-slate-100 whitespace-nowrap text-ellipsis">
          {{ row.original.agent }}
        </h6>
        <span class="text-xs text-slate-600 dark:text-slate-200">
          {{ row.original.email }}
        </span>
      </div>
    </div>
  </BaseCell>
</template>